import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { isMobileBrowser } from '../../../environment/utils';
import Icon from '../../../icons/components/Icon';
const useStyles = makeStyles((theme) => {
    return {
        button: {
            padding: '2px',
            backgroundColor: theme.palette.action03,
            border: 0,
            outline: 0,
            borderRadius: `${theme.shape.borderRadius}px`,
            '&:hover': {
                backgroundColor: theme.palette.ui02
            },
            '&:active': {
                backgroundColor: theme.palette.ui03
            },
            '&.is-mobile': {
                padding: '10px'
            }
        }
    };
});
const ClickableIcon = ({ accessibilityLabel, icon, onClick }) => {
    const styles = useStyles();
    const isMobile = isMobileBrowser();
    return (React.createElement("button", { "aria-label": accessibilityLabel, className: clsx(styles.button, isMobile && 'is-mobile'), onClick: onClick },
        React.createElement(Icon, { size: 24, src: icon })));
};
export default ClickableIcon;
